/**
 * AI 跟单下单：币种下拉中的「用券下单」选项 value（勿与真实法币/USDT 代码冲突）
 */
export const AICOPY_ORDER_OPTION_VOUCHER = "__AICOPY_ORDER_OPTION_VOUCHER__";

export function isAicopyVoucherOrderOption(value) {
  return value === AICOPY_ORDER_OPTION_VOUCHER;
}

/**
 * 从 Next/router.query 判断是否应默认「用券下单」。
 * 支持：`payWithVoucher`（推荐）、`useVoucher`、`voucherPay`；
 * 值为 `1` / `true` / `yes`（不区分大小写）为真。
 * 可选 `userCouponId` / `user_coupon_id`：跟单页 OrderForm 内优先选中该券（须仍在可用列表中）。
 */
export function parsePayWithVoucherQuery(query) {
  if (!query || typeof query !== "object") return false;
  const raw = query.payWithVoucher ?? query.useVoucher ?? query.voucherPay;
  if (raw == null || raw === "") return false;
  const s = (Array.isArray(raw) ? raw[0] : String(raw)).trim().toLowerCase();
  return s === "1" || s === "true" || s === "yes";
}

/** 券卡片「Use」等外链带参进入（与手动打开 /aicopy 区分） */
export function isAicopyVoucherUseEntryQuery(query) {
  if (!query || typeof query !== "object") return false;
  if (parsePayWithVoucherQuery(query)) return true;
  const raw = query.userCouponId ?? query.user_coupon_id;
  if (raw == null || raw === "") return false;
  const s = Array.isArray(raw) ? raw[0] : raw;
  return String(s).trim() !== "";
}
